import { useQuery } from '@tanstack/react-query';
import { rolesApi } from '../api/roles.api';
import type { AdminRolesListParams, AdminRolesPagedResult } from '../types/role.types';
import { roleKeys } from './queryKeys';

export const useRoles = (params: AdminRolesListParams = {}) => {
  return useQuery({
    queryKey: roleKeys.list(params),
    queryFn: async (): Promise<AdminRolesPagedResult> => {
      const response = await rolesApi.listRoles(params);
      return response.data;
    },
    staleTime: 1000 * 60 * 10,
  });
};
